import { ShieldCheck, Award, HardHat, BadgeCheck, Wrench, Flame } from "lucide-react";
import { ACCREDITATIONS } from "@/lib/site";

const ICONS = { ShieldCheck, Award, HardHat, BadgeCheck, Wrench, Flame };

export default function Accreditations({ variant = "light" }) {
  const dark = variant === "dark";
  return (
    <section
      data-testid="accreditations-strip"
      className={`border-y ${dark ? "bg-brand-ink text-white border-white/10" : "bg-white text-brand-ink border-black/10"}`}
    >
      <div className="container-lf py-10">
        <div className="text-center mb-8">
          <span className="eyebrow">Trusted &amp; Accredited</span>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-3 max-w-4xl mx-auto gap-6">
          {ACCREDITATIONS.map((a) => {
            const Icon = ICONS[a.icon] || ShieldCheck;
            if (a.logo) {
              return (
                <div
                  key={a.label}
                  title={a.label}
                  className={`flex items-center justify-center py-4 px-3 border ${
                    dark ? "border-white/10 hover:border-brand" : "border-black/10 hover:border-brand"
                  } transition-colors`}
                >
                  <img src={a.logo} alt={a.label} className="h-14 md:h-16 w-auto object-contain" />
                </div>
              );
            }
            return (
              <div
                key={a.label}
                className={`flex items-center gap-3 justify-center py-4 border ${
                  dark ? "border-white/10 hover:border-brand" : "border-black/10 hover:border-brand"
                } transition-colors`}
              >
                <Icon className="w-6 h-6 text-brand shrink-0" strokeWidth={1.75} />
                <span className="text-xs md:text-sm font-semibold uppercase tracking-wider">{a.label}</span>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
